import { TIPTAP_CAPTION_TYPE } from './../ricos-content/consts';
import type { EditorPlugin } from './../ricos-types';

import { captionConverter } from './converter/caption-converter';
import { captionTiptapExtension } from './tiptap/caption-tiptap-extension';
import { figureTiptapExtension } from './tiptap/figure-tiptap-extension';

export const pluginFigure: EditorPlugin = {
  type: TIPTAP_CAPTION_TYPE,
  config: {},
  pmMarkConverters: [],
  pmNodeConverters: [captionConverter],
  tiptapExtensions: [figureTiptapExtension, captionTiptapExtension],
};
